import { Link } from '@tanstack/react-router';
import { formatPublishedAt } from '../../../lib/format-date';
import type { ArticleCardData } from './ArticleCard';
import { SmartImage } from '../../../components/media/SmartImage';
import { CategoryLink } from '../../../components/CategoryLink';

type RegionalColumnProps = {
  items: ArticleCardData[];
  regionLabel: string;
};

function RegionalColumn({ items, regionLabel }: RegionalColumnProps) {
  const first = items[0];
  const rest = items.slice(1);
  if (!first) {
    return <div className="col-lg-4" />;
  }
  return (
    <div className="col-lg-4">
      <div className="trending-news-item">
        <div className="trending-news-thumb">
          <SmartImage media={first.coverMedia} alt={first.title} />
          {/* Icon-only link: the name comes from aria-label, otherwise both
              crawlers and screen readers see an anchor with no text at all. */}
          <div className="icon">
            <Link
              to="/articles/$slug"
              params={{ slug: first.slug }}
              aria-label={first.title}
            >
              <i className="fas fa-bolt" aria-hidden="true" />
            </Link>
          </div>
        </div>
        <div className="trending-news-content">
          <div className="post-meta">
            {first.category && (
              <div className="meta-categories">
                <CategoryLink slug={first.category.slug} name={first.category.name} />
              </div>
            )}
            <div className="meta-date">
              <span>{formatPublishedAt(first.publishedAt)}</span>
            </div>
          </div>
          <h3 className="title">
            <Link to="/articles/$slug" params={{ slug: first.slug }}>
              {first.title}
            </Link>
          </h3>
        </div>
      </div>
      <div className="trending-news-post-items">
        {rest.map((item) => (
          <div className="gallery_item" key={item.id}>
            <div className="gallery_item_thumb">
              <SmartImage media={item.coverMedia} alt={item.title} />
              <div className="icon"><i className="fas fa-bolt" /></div>
            </div>
            <div className="gallery_item_content">
              <div className="post-meta">
                {item.category && (
                  <div className="meta-categories">
                    <CategoryLink slug={item.category.slug} name={item.category.name} />
                  </div>
                )}
                <div className="meta-date">
                  <span>{formatPublishedAt(item.publishedAt)}</span>
                </div>
              </div>
              <h4 className="title">
                <Link to="/articles/$slug" params={{ slug: item.slug }}>
                  {item.title}
                </Link>
              </h4>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function RegionalsSection({
  asfis,
  marrakechs,
  otherRegions,
}: {
  asfis: ArticleCardData[];
  marrakechs: ArticleCardData[];
  otherRegions: ArticleCardData[];
}) {
  if (asfis.length === 0 && marrakechs.length === 0 && otherRegions.length === 0) return null;
  return (
    <section className="trending-news-area">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title">
              <h3 className="title">أخبار الجهة</h3>
            </div>
            <div className="row trending-news-slider">
              <RegionalColumn items={asfis} regionLabel="آسفي" />
              <RegionalColumn items={marrakechs} regionLabel="مراكش" />
              <RegionalColumn items={otherRegions} regionLabel="جهات أخرى" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
